export default __webpack_public_path__ + "static/media/magic-tiles@2x.ce4f8539.webp";